import CookiesStore from "./Storage/cookiesStore";

class AgeRestrictedContext {
    static accepted = false;
    static alcohol = false;
    static checked = false;

    static initialize(disabled: boolean) {
        if (disabled) {
            this.accepted = true;
        } else {
            const value = CookiesStore.get("age_restricted_accepted");
            this.accepted = value === "true";
        }
    }

    static setAlcohol(value: any) {
        this.alcohol = value;
    }

    static isAlcohol() {
        return this.alcohol;
    }

    static isAccepted(disabled: boolean) {
        if (!this.accepted) this.initialize(disabled);
        
        return this.accepted;
    }

    static accept() {
        CookiesStore.set("age_restricted_accepted", true);
        this.accepted = true;
    }

    static isItemEnergyDrink(value: any) {
        return !!(value.custom_fields && value.custom_fields.drink_type && value.custom_fields.drink_type == "energy_drink");
    }

    static isItemAlcohol(value: any) {
        return !!(value.custom_fields && value.custom_fields.drink_type && value.custom_fields.drink_type == "alcohol");
    }

    static setChecked(value: boolean) {
        this.checked = value;
    }

    static alreadyChecked() {
        return this.checked;
    }
}

export default AgeRestrictedContext;
